exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/object-get-own-property-symbols.js
// module id = 414
// module chunks = 0